import type { ComponentPropsWithRef } from 'react';

import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';
import { clsx } from '~/styles/utils';

import { useNavigationContext } from './Navigation.context';
import { titleStyle } from './Navigation.css';

type Props = ComponentPropsWithRef<'p'> & {
  children: string;
};

export const NavigationTitle = ({ children, className, ...delegated }: Props) => {
  const { isCollapsed } = useNavigationContext();
  const isMobile = useMediaQuery(breakpoints.small);

  if (isCollapsed && !isMobile) {
    return null;
  }

  return (
    <p {...delegated} className={clsx(titleStyle, className)}>
      {children}
    </p>
  );
};
